import React from 'react'

function Banner(props) {
  return (
    <div className="bg-grey-100 border-t border-black border-opacity-10 py-10">
      {props.banner && (
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-center xl:justify-between flex-wrap">
            <div className="flex flex-col xl:flex-row items-center justify-center xl:justify-start mb-4 xl:mb-0">
              {props.banner.icon && (
                <div className="hidden md:flex bg-white rounded-3xl w-12 h-12 justify-center items-center mr-4  mb-3 xl:mb-0 shadow-sm">
                  <img src={props.banner.icon} alt="contact" />
                </div>
              )}
              <h4 className="text-base text-center md:text-left font-bold uppercase tracking-medium">
                {props.banner.title}
              </h4>
            </div>
            <div className="flex flex-wrap w-full md:justify-center xl:justify-end xl:w-auto">
              {props.banner.ctas &&
                props.banner.ctas.map((button, i) => {
                  return (
                    <div
                      key={`banner-btn-${i}`}
                      className={`${
                        props.banner.ctas.length === 2 ? 'w-full sm:w-1/2' : 'w-full'
                      } p-3 flex justify-center md:w-auto`}
                    >
                      <a
                        href={button.href}
                        className={`${
                          i === 0
                            ? 'bg-blue-100 bg-gradient-to-r hover:bg-blue-700 text-white'
                            : 'box-border bg-transparent border-2 hover:bg-grey-200'
                        }  w-full md:w-auto px-4 py-3 inline-block text-center min-w--250 text-base lg:text-xl whitespace-nowrap rounded-lg`}
                      >
                        {button.text}
                      </a>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Banner
